import { DateComparator } from "../../../components/common/DateComparator";

export const LTTicketSummaryTableHeaders = [
    { field: "alIdentifier", headerName: "AL Identifier" ,pinned: true},
    { field: "menu", headerName: "Menu" },
    { field: "submenu", headerName: "Sub Menu" },
    { field: "category", headerName: "Category" },
    { field: "urgency", headerName: "Priority" }, 
   
    {
        field: "ticketNumber", headerName: "Ticket Number",
        cellRenderer: (response) => {
            return (
                response?.data?.ticketNumber ?
                    <span><a href={`${process.env.REACT_APP_MS_DYNAMICS_TICKET_BASE_URL}&id=${response?.data?.ticketId}`} target="_blank" style={{ color: '#000', cursor: 'pointer' }}>{response?.value || "-"}</a></span>
                    :
                    <span>{response?.value || "-"}</span>
            )
        }
    },
    
    { field: "status", headerName: "Status" },
    {
        field: "creationDate", headerName: "Creation Date (UTC)",
        comparator: DateComparator,
    },
    { field: "afcusersupportticketseqid", headerName: "ID" },
]

